import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {compose, lifecycle} from 'recompose'
import {injectIntl} from 'react-intl'

import {getFullActionInfo} from '../selectors/actions.js'
import {getAction} from '../store/reducers/actions/list.js'
//import { getLots, getPersons, clear } from '../store/reducers/funds/fund.js'
import {getFunds, clear} from '../store/reducers/actions/action.js'

import MainContainer from './Main'
import SingleList from './LotList/singleList'
import Sidebar from './../components/Fund/Sidebar'
import BidHistory from '../components/Lot/BidHistory'
import DonationStats from '../components/Fund/DonationStats'
import numeral from 'numeral'
import Link from './../components/Link'
import moment from 'moment'
import PdfLogo from '../components/Icons/Pdf'

const ActionPage = ({info, funds = [], intl}) => {
	console.log('info',info);
  //формирование ссылки на офертву в зависимости от того где она лежит
  if (info && info.linkToOffer == null) {
    info.linkToOffer = info._id + '/offer'
  }
  if (info) return (

    <div className='Container'>
      <div className="Action">
        <div className="Action__first">
          <div className="Action__col">
            <div className='Action__head'>{info.title}</div>
            <img className='Action__logo' src={info.image}/>
            <a href={info.linkToPartner} target='_blank' className='Link Link_orange Action__link'>Ссылка на страницу
              акции у партнера</a>
            {(info._id == '60bf9610f89f151eae14f734') ? (<Link to='/donate/kynsi' target="_blank">
              <button className='Button Button_black'>
              Хочу помочь!
              </button>
            </Link>) : ('')}
            <div className='Action__row'>
              <div className='Action__row-orange'>Сроки:&nbsp;</div>
              с {moment(info.startDate).format('DD MMM YYYY', 'ru')} по {moment(info.closeDate).format('DD MMM YYYY', 'ru')}
            </div>
            <div className='Home__item-row-center'>
          </div>
            <div className='Action__row'>
            <pre>
              <span className='Action__row-orange'>Механика: </span>{info.mechanic}
            </pre>
            </div>
            <div className='Action__row'>
              <span className='Action__row-orange'>Дополнительно: </span>
              <a href={info.linkToOffer} target='_blank' className='Link Link_orange Action__link-inline'>Оферта</a>
            </div>
            {(info._id == '60bf9610f89f151eae14f734') ? (<Link to='/donate/kynsi' target="_blank">
              <button className='Button Button_black'>
              Хочу помочь!
              </button>
            </Link>) : ('')}
          </div>
          <div className="Action__col-right">
            <div
              className='Action__donations'>Собрано {(numeral(info.externalPaymentsStats.sum).format('0,0') == 0) ? 'coming soon' : (numeral(info.externalPaymentsStats.sum).format('0,0') + ' ₽')}</div>
            <div
              className='Action__donations-small'>{(numeral(info.externalPaymentsStats.personsCount).format('0,0') == 0) ? 'coming soon' : (info.externalPaymentsStats.personsCount + ' человек ')} участвовали
              в акции
            </div>
          </div>
        </div>

        {}
        <div className='Action__description' dangerouslySetInnerHTML={{__html: info.description}}/>


        <div className='Action__list'>
          {funds.length > 0 && <div className='Action__list-header'>Фонды</div>}
          {funds.map(el => (
            <div className='Action__list-row' key={el._id}>
              <div className='Action__list-col'>{el.name}
                <sup
                  className='Action__list-col-superscript'>(с {moment(info.startDate).format('DD.MM.YY')} по {moment(info.closeDate).format('DD.MM.YY')})</sup>
              </div>
              <div
                className='Action__list-col-right'>{(numeral(el.sum).format('0,0') == 0) ? 'coming soon' : (numeral(el.sum).format('0,0') + ' ₽')}
                {/*<button type="button" className="Action__pdf-button"><PdfLogo /></button>*/}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

  ); else return null
}

const mapStateToProps = () => {
  const getInfo = getFullActionInfo()
  return (state, props) => {
    return ({
      info: getInfo(state, props),
      ...state.actions.action
    })
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getAction,
  getFunds, //getLots, getPersons, 
  clear
}, dispatch)

const mergeProps = (state, dispatch, props) => {
  const getDetails = async (id) => {
    if (!id) return
    await Promise.all([
      dispatch.getFunds(id),
    ])
  }
  const getInfo = async (id) => {
	  console.log('---------------props',props);
    id = id || props.id
    if (!id) return
    //console.log('id', id)
    let code
    if (!props.info) code = await dispatch.getAction(id)
    if (props.info || code === 200) await getDetails(id)
    if (!props.info && code !== 200) props.on404()
  }
  return {...props, ...state, getInfo}
}

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    async componentWillMount() {
      await this.props.getInfo()
    },
    componentWillReceiveProps(np) {//console.log('np',np);console.log('this.props.id',this.props.id)
      if (np.id !== this.props.id) this.props.getInfo(np.id)
    }
  })
)(ActionPage))



// WEBPACK FOOTER //
// ./src/containers/Action.jsx